import classNames from 'classnames';
import React from 'react';
import './ShadowBox.scss';

const ShadowBox = ({ children, className }) => (
  <div className={classNames(className, 'shadow-box')}>{children}</div>
);

export default ShadowBox;
